export const expiryPriority = {
    most: {
        text: "#FF0000",
        background: "#FFE3E3"
    },
    moderate: {
        text: "#002385",
        background: "#D9E9FF"
    },
    least: {
        text: "#E57E00",
        background: "#FFF4D3"
    }
};
